import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Title } from '../layout';

class EventListComponent extends Component {
  render() {
    const { currentSession } = this.props.auth;

    return (
      <div>
        <Title title="Events"/>
        <h1 className="page-header">
          Event Calendar
        </h1>
        <p>
          {currentSession.user.firstName}'s event calendar goes here
        </p>
      </div>
    );
  }
}

EventListComponent.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = ({ auth }) => {
  return {
    auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventListComponent);



// WEBPACK FOOTER //
// src/events/event-list.component.js